import {GTAG_KEY} from '../../app.constants';

declare global {
    interface Window {
      gtag: any;
      decodeURI: any;
      encodeURIComponent: any;
      unescape: any;
      lintrk: any;
    }
}

export const GA_TRACKING_ID = GTAG_KEY;
interface GTagEvent {
    action: string;
    category: string;
    label: string;
    value: number;
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string) => {
    window.gtag('config', GA_TRACKING_ID, {
        page_path: url
    });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }: GTagEvent) => {
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
    });
};

export const stop = () => {
    (window as any).gtag('config', '');
    (window as any).gtag('js', '');
    (window as any).gtag('set', 'sendHitTask', null);
    (window as any)['ga-disable-G-YFMDH3G8KT'] = true;
};

export const start = () => {
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', GTAG_KEY);
};
